import { TrackingEvent } from '../../../Entities/Schema.entity';

import { createAlertConfirmationSchema } from './CreateAlertConfirmationSchema';

export type CreateAlertConfirmationEvent = TrackingEvent<Record<any, any>>;

export const createAlertConfirmationToEvent = (): CreateAlertConfirmationEvent => {
  const event: CreateAlertConfirmationEvent = {
    schema: createAlertConfirmationSchema.ref,
    data: {},
  };

  return event;
};
